import { useQuery } from 'react-query';
import { errorHandler } from 'App/utils';
import PESService from 'App/services/PESService';

/*
fetch list of medications based on therapy id
 */
function useFetchMedicationsQuery(therapyId) {
    return useQuery(['therapyId', therapyId, 'medications'], () => PESService.getAllMedications(therapyId), {
        onError: (error) => {
            errorHandler(error);
        },
        enabled: !!therapyId,
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchMedicationsQuery;
